import { gql } from '@apollo/client';
const GET_PRODUCT_EVENTS = gql `
  query GetProductEvents($first: Int = 25, $after: String = "") {
    autocomplete {
      productEvents(first: $first, after: $after) {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            id
            name
            description
            thumbnail
          }
        }
      }
    }
  }
`;
export default GET_PRODUCT_EVENTS;
